export enum OrderTypes {
    VEHICLE = "Pojazd",
    WEIGHT = "Tonaż",
    CONTAINER = "Kontener"
}